import { getCenter } from './helpers';

export function renderEditIcon(group, iconCenter) {
  const width = 28;
  const height = 28;
  group.createImage({
    x: iconCenter.x - width / 2,
    y: iconCenter.y - height / 2,
    width: width,
    height: height,
    src: 'images/configurator/pen-full.svg',
  });
}

export function switchCursor(group, cursorStyle) {
  dojo.style(group.rawNode, 'cursor', cursorStyle);
}

export function renderBaseBorder(group, startPoint, endPoint, isClockwise) {
  const iconWidth = 10;
  const iconHeight = 20;
  const borderWidth = 4;
  const borderCenter = getCenter(startPoint, endPoint);

  group.createLine({ x1: startPoint.x, y1: startPoint.y, x2: endPoint.x, y2: endPoint.y }).setStroke({
    color: 'black',
    width: borderWidth,
    cap: 'round',
  });

  const icon = group.createImage({
    x: borderCenter.x - iconWidth / 2,
    y: borderCenter.y - iconHeight / 2,
    width: iconWidth,
    height: iconHeight,
    src: 'images/configurator/arrow-border.svg',
  });
  const angle = Math.atan((startPoint.y - endPoint.y) / (startPoint.x - endPoint.x)) * (180 / Math.PI);
  let rotation = 0;
  if (Object.is(angle, -0) || angle < 0) {
    rotation = angle + 180;
  } else {
    rotation = angle;
  }

  if (!isClockwise) {
    rotation += 180;
  }
  icon.setTransform([
    dojox.gfx.matrix.rotategAt(startPoint.y < endPoint.y ? rotation + 180 : rotation, borderCenter.x, borderCenter.y),
    dojox.gfx.matrix.translate(0, iconHeight / 2 + borderWidth / 2),
  ]);
}

export function hideGroup(group) {
  group.rawNode.style.display = 'none';
}

export function showGroup(group) {
  group.rawNode.style.display = 'block';
}

export function showNode(node, value = 'block') {
  node.style.display = value;
}

export function hideNode(node) {
  node.style.display = 'none';
}

/**
 * This function is used to hide an HTML <option> element and disable it.
 * It works around the limitation in Safari where the option element cannot be hidden using CSS.
 * For Safari it will be disabled, for all other browsers, the <option> element will be visually hidden.
 * 
 * @param {HTMLElement} node - The option element to be "hidden".
 */
export function hideOptionNode(node) {
  hideNode(node);
  node.disabled = 'disabled';
}

/**
 * This function is used to show a HTML <option> element hidden by hideOptionNode function.
 * 
 * @param {HTMLElement} node - The option element to be displayed and enabled.
 * @param {string} [value='block'] - The display style value to be set. Default is 'block'.
 */
export function showOptionNode(node, value = 'block') {
  showNode(node, value);
  node.disabled = '';
}

